import * as api from '../api';

// set user in redux store
export const SET_USER = 'SET_USER';
export const setUser = (user, overwrite) => {
  return {
    type: SET_USER,
    user,
    overwrite // flag for replacing with passed user object
  }
};

// dispatches action that reducers watch for and clear there data
export const LOGOUT_USER = 'LOGOUT_USER';
export const logoutUser = () => {
  return { type: LOGOUT_USER }
};


// ASYNC ACITONS:

// update user in server
export const updateUser = (user) => (dispatch) =>
  api.updateUser(user).then(response => {
    dispatch(setUser(user))
    return user;
  });

// send password reset email
export const resetUserPassword = (email) => (dispatch) =>
  api.resetUserPassword(email);

// update users password using token for auth
export const updateUserPasswordWithToken = (newPassword, resetToken) => (dispatch) =>
  api.updateUserPasswordWithToken(newPassword, resetToken);

// get user info from server
export const getUser = () => (dispatch) =>
  api.getUser()
    .then(user => {
      if (user) {
        dispatch(setUser(user));
        return user;
      } else {
        // TODO: this should be handled server side by returning 404.  Was getting empty user object
        dispatch(logoutUser());
      }
    })
    .catch(err => {
      console.log('err: ', err.response);
      if (err.response && (err.response.status === 401 || err.response.status === 404)) {
        // user never returned from db, ensure redux state is clear
        dispatch(logoutUser());
      }
    });


// register new user to server
export const registerUser = (user) => (dipatch) =>
  api.registerUser(user).then(response => dipatch(setUser(user)));


export const updateUserNewsSub = (newsletters) => (dispatch) =>
  api.newsletterSubscribe(newsletters)
    .then(res => {
      dispatch(setUser(newsletters))
      return newsletters;
    });


export const getUserNewsSub = () => (dispatch) =>
  api.getUserNewsSub().then(data => {
    const dailyBoost = data.dailyBoost === 'Subscribed';
    const salesDigest = data.salesDigest === 'Subscribed';

    dispatch(setUser({ dailyBoost, salesDigest, thirdParty: data.thirdParty }));
  });



// WEBPACK FOOTER //
// ./src/actions/user.js